import subsidiariesImage from "@assets/images/about-us/subsidiaries.png";
import { trans } from "@mongez/localization";

/**
 * Subsidiaries content header section
 * Displays the title, description paragraphs, and image placeholder
 */
export function SubsidiariesHeaderSection() {
  return (
    <section className="3xl:mb-24 container mb-12 sm:mb-16 md:mb-20">
      <h3 className="3xl:max-w-[1200px] mb-6 max-w-full text-2xl font-medium leading-tight tracking-[-0.03rem] text-secondary sm:mb-8 sm:max-w-[800px] sm:text-3xl sm:leading-snug md:mb-10 md:max-w-[1070px] md:text-4xl md:leading-tight lg:text-5xl xl:text-6xl">
        {trans("aboutUsPage.leadership.subsidiaries.title")}
      </h3>
      <div className="3xl:gap-12 flex flex-col items-center justify-between gap-6 sm:gap-8 md:gap-10 lg:flex-row">
        <div className="3xl:text-3xl w-full space-y-4 text-sm font-light text-marine sm:space-y-5 sm:text-base md:space-y-6 md:text-lg lg:max-w-[60%] lg:flex-1 lg:text-xl xl:max-w-[55%] xl:text-2xl">
          <p>{trans("aboutUsPage.leadership.subsidiaries.paragraph1")}</p>
          <p>{trans("aboutUsPage.leadership.subsidiaries.paragraph2")}</p>
          {/* <p>{trans("aboutUsPage.leadership.subsidiaries.paragraph3")}</p>
          <p>{trans("aboutUsPage.leadership.subsidiaries.paragraph4")}</p> */}
        </div>

        <div className="w-full lg:w-auto lg:flex-shrink-0">
          <img
            src={subsidiariesImage}
            alt="Social Responsibility"
            className="3xl:w-[650px] h-48 w-full rounded-2xl object-cover sm:h-56 sm:rounded-3xl md:h-64 lg:h-auto lg:w-[350px] xl:w-[450px] 2xl:w-[550px]"
          />
        </div>
      </div>
    </section>
  );
}
